// components/socials/PostComments.jsx
import { useEffect, useState } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import { FiSend, FiTrash2, FiX } from "react-icons/fi";
import { db } from "../../firebase/firebase.utils";

export default function PostComments({ post, currentUser, onClose }) {
  const [comments, setComments] = useState([]);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  useEffect(() => {
    if (!post?.id) return undefined;
    return db
      .collection("posts")
      .doc(post.id)
      .collection("comments")
      .orderBy("created", "desc")
      .limit(15)
      .onSnapshot(
        (snapshot) =>
          setComments(
            snapshot.docs.map((item) => ({ id: item.id, ...item.data() })),
          ),
        (error) => console.log("Post comments snapshot error:", error),
      );
  }, [post?.id]);
  const submit = async (event) => {
    event.preventDefault();
    const cleanMessage = message.trim();
    if (!cleanMessage || !currentUser?.uid || sending || post?.moderationHidden)
      return;
    try {
      setSending(true);
      await db
        .collection("posts")
        .doc(post.id)
        .collection("comments")
        .add({
          message: cleanMessage,
          from: currentUser.uid,
          fromName: currentUser.userName || "User",
          frompostId: post.id,
          created: firebase.firestore.FieldValue.serverTimestamp(),
          reaction: "",
          repliedTo: null,
        });
      setMessage("");
    } catch (error) {
      console.log("Comment submit error:", error);
      window.alert("The comment could not be sent.");
    } finally {
      setSending(false);
    }
  };
  const removeComment = async (comment) => {
    if (comment.moderationHidden || comment.from !== currentUser?.uid) return;
    if (!window.confirm("Delete this comment?")) return;
    try {
      await db
        .collection("posts")
        .doc(post.id)
        .collection("comments")
        .doc(comment.id)
        .delete();
    } catch (error) {
      console.log("Comment delete error:", error);
      window.alert("The comment could not be deleted.");
    }
  };
  if (post?.moderationHidden)
    return (
      <section className="post-comments">
        <p role="status">This post was removed by moderation.</p>
        <button type="button" onClick={onClose}>
          Close comments
        </button>
      </section>
    );
  return (
    <section className="post-comments" onClick={(e) => e.stopPropagation()}>
      <header className="post-comments__header">
        <strong>Comments</strong>
        <button type="button" onClick={onClose} aria-label="Close comments">
          <FiX />
        </button>
      </header>
      <div className="post-comments__list">
        {!comments.length && (
          <p className="post-comments__empty">No comments yet.</p>
        )}
        {comments.map((comment) => (
          <article className="post-comment" key={comment.id}>
            {comment.moderationHidden ? (
              <p role="status" style={{ fontStyle: "italic" }}>
                This comment was removed by moderation.
              </p>
            ) : (
              <>
                <div>
                  <strong>{comment.fromName || "User"}</strong>
                  <p>{comment.message}</p>
                </div>
                {comment.from === currentUser?.uid && (
                  <button
                    type="button"
                    onClick={() => removeComment(comment)}
                    aria-label="Delete comment"
                  >
                    <FiTrash2 />
                  </button>
                )}
              </>
            )}
          </article>
        ))}
      </div>
      <form className="post-comments__form" onSubmit={submit}>
        <textarea
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          placeholder={currentUser ? "Write a comment" : "Sign in to comment"}
          disabled={!currentUser || sending}
          rows={1}
        />
        <button
          type="submit"
          disabled={!message.trim() || !currentUser || sending}
          aria-label="Send comment"
        >
          <FiSend />
        </button>
      </form>
    </section>
  );
}
